module.exports = __webpack_public_path__ + "static/7-7e80426b25c7ff4cfb278eb9cf41f98a.jpg";